(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1169],{

/***/ 65736:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/team",
      function () {
        return __webpack_require__(90893);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_icons_vsc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14578);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79352);





const AccountMenu = ()=>{
    const { pathname  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/account",
                className: pathname === "/account" ? "group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-200 focus:outline-none  focus:bg-gray-200 transition ease-in-out duration-150" : "group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:bg-gray-200 focus:outline-none  focus:bg-gray-200 transition ease-in-out duration-150",
                "aria-current": "page",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        className: `flex-shrink-0 -ml-1 mr-3 h-6 w-6 transition ease-in-out duration-150 ${pathname === "/account" ? "text-gray-900 group-" : "text-gray-500 group-focus:text-gray-500"}`,
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "2",
                            d: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "truncate",
                        children: "General"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/account/api-access",
                className: pathname === "/account/api-access" ? "mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-200 focus:outline-none  focus:bg-gray-200 transition ease-in-out duration-150" : "mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:bg-gray-200 focus:outline-none  focus:bg-gray-200 transition ease-in-out duration-150",
                "aria-current": "page",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_vsc__WEBPACK_IMPORTED_MODULE_3__/* .VscDebugDisconnect */ .ZUl, {
                        className: `flex-shrink-0 -ml-1 mr-3 h-6 w-6 transition ease-in-out duration-150 ${pathname === "/account/api-access" ? "text-gray-900 group-" : "text-gray-500 group-focus:text-gray-500"}`
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "truncate",
                        children: "API access"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/account/billing",
                className: pathname === "/account/billing" ? "mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-200 focus:outline-none  focus:bg-gray-200 transition ease-in-out duration-150" : "mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:bg-gray-200 focus:outline-none  focus:bg-gray-200 transition ease-in-out duration-150",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        className: `flex-shrink-0 -ml-1 mr-3 h-6 w-6 transition ease-in-out duration-150 ${pathname === "/account/billing" ? "text-gray-900 group-" : "text-gray-500 group-focus:text-gray-500"}`,
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "2",
                            d: "M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "truncate",
                        children: "Subscription"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/account/team",
                className: pathname === "/account/team" ? "mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-200 focus:outline-none  focus:bg-gray-200 transition ease-in-out duration-150" : "mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:bg-gray-200 focus:outline-none  focus:bg-gray-200 transition ease-in-out duration-150",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        className: `flex-shrink-0 -ml-1 mr-3 h-6 w-6 transition ease-in-out duration-150 ${pathname === "/account/team" ? "text-gray-900 group-" : "text-gray-500 group-focus:text-gray-500"}`,
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeWidth: "2",
                            d: "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "truncate",
                        children: "Team"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: "/account/slack",
                className: pathname === "/account/slack" ? "mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-200 focus:outline-none  focus:bg-gray-200 transition ease-in-out duration-150" : "mt-1 group flex items-center px-3 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:bg-gray-200 focus:outline-none  focus:bg-gray-200 transition ease-in-out duration-150",
                "aria-current": "page",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_4__/* .RiSlackLine */ .zrR, {
                        className: `flex-shrink-0 -ml-1 mr-3 h-6 w-6 transition ease-in-out duration-150 ${pathname === "/account/slack" ? "text-gray-900 group-" : "text-gray-500 group-focus:text-gray-500"}`
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "truncate",
                        children: "Slack integration"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AccountMenu);


/***/ }),

/***/ 54087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


const BreadCrumbs = (param)=>{
    let { breadCrumbs  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                className: "sm:hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: breadCrumbs.back.path,
                    className: "flex items-center text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out hover:text-gray-500 focus:outline-none focus:underline",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                            className: "flex-shrink-0 w-5 h-5 mr-1 -ml-1 text-gray-500",
                            fill: "currentColor",
                            viewBox: "0 0 20 20",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                fillRule: "evenodd",
                                d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
                                clipRule: "evenodd"
                            })
                        }),
                        "Back"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
                className: "items-center hidden text-sm font-medium leading-5 sm:flex",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: breadCrumbs.first.path,
                        className: "text-gray-600 transition duration-150 ease-in-out hover:text-gray-500 focus:outline-none focus:underline",
                        children: breadCrumbs.first.text
                    }),
                    breadCrumbs.second && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                className: "flex-shrink-0 w-5 h-5 mx-2 text-gray-500",
                                fill: "currentColor",
                                viewBox: "0 0 20 20",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                    fillRule: "evenodd",
                                    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                    clipRule: "evenodd"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: breadCrumbs.second.path,
                                className: "text-gray-600 transition duration-150 ease-in-out hover:text-gray-500 focus:outline-none focus:underline",
                                children: breadCrumbs.second.text
                            }),
                            breadCrumbs.third && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        className: "flex-shrink-0 w-5 h-5 mx-2 text-gray-500",
                                        fill: "currentColor",
                                        viewBox: "0 0 20 20",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            fillRule: "evenodd",
                                            d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
                                            clipRule: "evenodd"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        href: breadCrumbs.third.path,
                                        className: "text-gray-600 transition duration-150 ease-in-out hover:text-gray-500 focus:outline-none focus:underline",
                                        children: breadCrumbs.third.text
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbs);


/***/ }),

/***/ 90927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const ConfirmModal = (param)=>{
    let { closeModal , title , text , confirmText , confirmAction , cancelText  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed inset-0 transition-opacity",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "absolute inset-0 bg-gray-500 opacity-75"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "sm:flex sm:items-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "h-6 w-6 text-red-600",
                                    stroke: "currentColor",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        strokeWidth: "2",
                                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-lg leading-6 font-medium text-gray-900",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-2",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-sm leading-5 text-gray-500",
                                            children: text
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    className: "inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5",
                                    onClick: confirmAction,
                                    children: confirmText || "Confirm"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    className: "inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150 sm:text-sm sm:leading-5",
                                    onClick: closeModal,
                                    children: cancelText || "Cancel"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ConfirmModal);


/***/ }),

/***/ 56925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);




const SEO = (props)=>{
    const { title , description , prefix , image  } = props;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const formattedTitle = title ? title : `${prefix ? `${prefix} | ` : ""}Latency Lingo`;
    const twitterTitle = title ? title : "Simple and collaborative performance testing analytics";
    const formattedImage = image ? `https://latencylingo.com/${image}` : "https://latencylingo.com/img/logo_full_v2.png";
    const formattedDescription = description ? description : "Latency Lingo helps software engineering teams gain insights on web performance testing metrics.";
    const formattedUrl = `https://latencylingo.com${router.asPath}`;
    const GoogleAnalytics = ()=>{
        if ( false || window.location.hostname == "localhost") {
            return null;
        }
        const gtags = [
            "G-NRT5TM5B5N",
            "UA-222320108-1"
        ];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                gtags.map((tag, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                        async: true,
                        src: `https://www.googletagmanager.com/gtag/js?id=${tag}`
                    }, i)),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                    dangerouslySetInnerHTML: {
                        __html: `
                  window.dataLayer = window.dataLayer || [];
                  function gtag(){dataLayer.push(arguments);}
                  gtag('js', new Date());
                  ${gtags.map((tag)=>`gtag('config', '${tag}');`).join("\n")}
              `
                    }
                })
            ]
        });
    };
    const ClearBitAnalytics = ()=>{
        if ( false || window.location.hostname == "localhost") {
            return null;
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
            async: true,
            src: "https://tag.clearbitscripts.com/v1/pk_0e056f1cd6a691121103023fd96c1f74/tags.js",
            referrerPolicy: "strict-origin-when-cross-origin"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(GoogleAnalytics, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ClearBitAnalytics, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: formattedTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: formattedDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: formattedImage,
                        property: "og:image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: formattedUrl,
                        property: "og:url"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: "website",
                        property: "og:type"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: formattedTitle,
                        property: "og:title"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        content: formattedDescription,
                        property: "og:description"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "slack-app-id",
                        content: "A03KZAGKH8Q"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: twitterTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: formattedDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: formattedImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image:alt",
                        content: "Latency Lingo"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: "/favicon/apple-touch-icon.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "32x32",
                        href: "/favicon/favicon-32x32.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16",
                        href: "/favicon/favicon-16x16.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "manifest",
                        href: "/favicon/site.webmanifest"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "mask-icon",
                        href: "/favicon/safari-pinned-tab.svg",
                        color: "#5bbad5"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "msapplication-TileColor",
                        content: "#2b5797"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "theme-color",
                        content: "#ffffff"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 30453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const Spinner = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        viewBox: "0 0 100 100",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M90.9 58.2c-3.8 18.9-20.1 32.7-39.7 33-22 .4-40.7-17-41.9-39C8 28.5 26.9 8.8 50.4 8.8c19 0 35.5 13.1 40 31.2.3 1.2 1.4 2.1 2.7 2.1 1.8 0 3.1-1.7 2.7-3.5C90.6 18.1 72 3.3 50.4 3.3c-27.2 0-49 23.4-46.6 51.1 2.1 23 21 41.2 44 42.4C71.6 98 91.7 81.9 96.2 59.4c.3-1.7-1-3.3-2.7-3.3-1.3-.1-2.4.8-2.6 2.1z"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 99627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_icons_Spinner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30453);


const Button = (param)=>{
    let { isLoading =false , title , children , ...buttonProps } = param;
    const { className , ...restButtonProps } = buttonProps;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        className: `w-full flex justify-center py-2 px-4 border border-summer-green-500 text-sm font-medium rounded-md text-san-juan-blue-500 bg-summer-green-400 hover:bg-summer-green-500 focus:outline-none transition duration-150 ease-in-out disabled:bg-gray-400 disabled:cursor-not-allowed ${className}`,
        ...restButtonProps,
        children: [
            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_Spinner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                width: "20",
                fill: "#304D63",
                className: "animate-spin"
            }) : title,
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 83062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const NotificationBar = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full h-full text-md py-2 text-center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "inline-block max-w-4xl px-8 text-center",
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NotificationBar);


/***/ }),

/***/ 16755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useRequireAuth; }
/* harmony export */ });
/* harmony import */ var hooks_useAuth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18424);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



const useRequireAuth = function() {
    let redirectUrl = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/login";
    const auth = (0,hooks_useAuth__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .a)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    // If auth.user is false that means we're not
    // logged in and should redirect.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const timed = setTimeout(()=>{
            if (!auth.user) {
                router.push(`${redirectUrl}?returnTo=${router.asPath}`);
            }
        }, 300);
        return ()=>clearTimeout(timed);
    }, [
        auth,
        redirectUrl,
        router
    ]);
    return auth;
};


/***/ }),

/***/ 90893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_dashboard_AccountMenu__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37365);
/* harmony import */ var components_dashboard_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54087);
/* harmony import */ var components_shared_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99627);
/* harmony import */ var components_dashboard_ConfirmModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90927);
/* harmony import */ var components_dashboard_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59319);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_icons_Spinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30453);
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15503);
/* harmony import */ var config_firebase__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82945);
/* harmony import */ var services_team__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(87536);
/* harmony import */ var hooks_useRequireAuth__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16755);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67294);
/* harmony import */ var hooks_useTeam__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(20715);
/* harmony import */ var hooks_useToast__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43551);
/* harmony import */ var components_home_SEO__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(56925);
/* harmony import */ var components_shared_NotificationBar__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(83062);


















const breadCrumbs = {
    back: {
        path: "/account",
        text: "Back"
    },
    first: {
        path: "/account",
        text: "Account"
    },
    second: {
        path: "/account/team",
        text: "Team"
    }
};
const Team = ()=>{
    const { register , handleSubmit , formState: { errors  } , reset  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_17__/* .useForm */ .cI)();
    const { addToast  } = (0,hooks_useToast__WEBPACK_IMPORTED_MODULE_14__/* .useToast */ .p)();
    const { user  } = (0,hooks_useRequireAuth__WEBPACK_IMPORTED_MODULE_11__/* .useRequireAuth */ .Q)();
    const { team  } = (0,hooks_useTeam__WEBPACK_IMPORTED_MODULE_13__/* .useTeam */ .t)();
    const [formOpen, setFormOpen] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    const [hasResendInvite, setHasResendInvite] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(null);
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(null);
    const [showConfirmModal, setShowConfirmModal] = (0,react__WEBPACK_IMPORTED_MODULE_12__.useState)(false);
    if (!user) return null;
    const getTeamInviteLink = ()=>{
        return `https://latencylingo.com/signup?teamId=${team.id}`;
    };
    const copyTeamInviteLink = ()=>{
        navigator.clipboard.writeText(getTeamInviteLink());
        addToast({
            title: "Link copied",
            description: "Pending team members can join your team by signing up with this link.",
            type: "success"
        });
    };
    const onSubmit = async (data)=>{
        setIsLoading(data.email);
        setError(null);
        const payload = {
            status: "invited",
            invitedAt: Date.now(),
            role: "member",
            ...data
        };
        (0,services_team__WEBPACK_IMPORTED_MODULE_10__/* .updateTeam */ .fs)(team.id, {
            users: firebase_app__WEBPACK_IMPORTED_MODULE_8__/* ["default"].firestore.FieldValue.arrayUnion */ .Z.firestore.FieldValue.arrayUnion({
                ...payload
            })
        }).then(()=>{
            // TODO(bobsin): enable the invite email flow once emails are working
            // const sendTeamInviteEmail = functions.httpsCallable(
            //   'sendTeamInviteEmail'
            // );
            // sendTeamInviteEmail({
            //   emailTo: data.email,
            //   teamName: team.name,
            //   teamId: team.id,
            //   teamOwnerName: user.name,
            // })
            //   .then(() => {
            reset({});
            setFormOpen(false);
            setIsLoading(false);
            addToast({
                title: "Pending team member added",
                description: "They can join your team by using the team sign up link",
                type: "success"
            });
        }).catch((error)=>{
            console.error("Error adding team member", error);
            addToast({
                title: "Failed to add team member",
                description: "Our team has been notified. Please try again later.",
                type: "error"
            });
        });
    };
    const resendInvite = (email)=>{
        setIsLoading(email);
        const sendTeamInviteEmail = config_firebase__WEBPACK_IMPORTED_MODULE_9__/* .functions.httpsCallable */ .wk.httpsCallable("sendTeamInviteEmail");
        sendTeamInviteEmail({
            emailTo: email,
            teamName: team.name,
            teamId: team.id,
            teamOwnerName: user.name
        }).then(()=>{
            setHasResendInvite(email);
            setFormOpen(false);
            setIsLoading(false);
            addToast({
                title: "Invite is sent ✉️",
                description: `Once again, an invitation email has been sent to ${email}.`,
                type: "success"
            });
        });
    };
    const deleteMember = (email)=>{
        setIsLoading(true);
        const updatedTeamMembers = team.users.filter((user)=>user.email !== email);
        const updatedTeam = {
            ...team,
            users: updatedTeamMembers
        };
        (0,services_team__WEBPACK_IMPORTED_MODULE_10__/* .updateTeam */ .fs)(team.id, updatedTeam).catch((error)=>setError(error)).finally(()=>{
            setIsLoading(false);
            setShowConfirmModal(false);
            addToast({
                title: "Member deleted",
                description: `The team member is successfully removed from the team`,
                type: "success"
            });
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_home_SEO__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                prefix: "Team"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_dashboard_Layout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "px-4 py-10 pb-12 mx-auto max-w-7xl sm:px-6 lg:px-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                                className: "pb-4 pl-3 mb-6 border-b-2 border-gray-300 sm:py-6",
                                children: [
                                    breadCrumbs && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dashboard_BreadCrumbs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        breadCrumbs: breadCrumbs
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-2 md:flex md:items-center md:justify-between",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "flex-1 min-w-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                className: "text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:leading-9 sm:truncate",
                                                children: team?.name || "Team"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full sm:w-1/3 sm:pr-16",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dashboard_AccountMenu__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                                        className: "w-2/3 mx-auto",
                                        children: [
                                            !team && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_icons_Spinner__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                width: "30",
                                                className: "m-auto mt-6 animate-spin"
                                            }),
                                            team && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "px-4 py-5 pt-5 mt-10 overflow-hidden bg-white rounded-lg shadow-lg sm:p-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                className: "text-lg font-medium leading-6 text-gray-900",
                                                                children: "Team members"
                                                            }),
                                                            team?.users && team.users.filter((user)=>user.status === "invited").length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "mt-4 rounded-lg bg-summer-green-100 font-medium text-summer-green-700 border border-summer-green-300 py-3",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_shared_NotificationBar__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                                                    children: [
                                                                        "Send pending team members to your team sign up link.",
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            target: "_blank",
                                                                            className: "underline",
                                                                            href: "https://docs.latencylingo.com/docs/accounts/setup",
                                                                            rel: "noreferrer",
                                                                            children: "Learn more."
                                                                        })
                                                                    ]
                                                                })
                                                            }) : null,
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                className: "mt-5",
                                                                children: team?.users.map((member, i)=>{
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        className: "border-t border-gray-200",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "flex items-center justify-between w-full py-6",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "flex-1 truncate",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                            className: "flex items-center space-x-3",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                                                    className: "text-sm font-medium leading-5 text-gray-900 truncate",
                                                                                                    children: member.email
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                    className: "flex-shrink-0 inline-block px-2 py-0.5 text-summer-green-700 text-xs leading-4 font-medium bg-summer-green-100 border border-summer-green-200 rounded-full",
                                                                                                    children: member.role
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                            className: "mt-1 text-sm leading-5 text-gray-500 truncate",
                                                                                            children: member.status === "active" ? `Joined on ${new Date(member.joinedAt).toLocaleDateString()}` : `Invited on ${new Date(member.invitedAt).toLocaleDateString()}`
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                    className: "flex",
                                                                                    children: [
                                                                                        member.status === "DOES NOT EXIST" && // member.status !== 'active' &&
                                                                                        user.isTeamOwner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                                            className: "inline-flex justify-center w-full px-4 py-2 mr-3 text-base font-medium leading-6 text-gray-700 transition duration-150 ease-in-out bg-white border border-gray-300 rounded-md shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5",
                                                                                            onClick: ()=>resendInvite(member.email),
                                                                                            children: isLoading === member.email ? "Sending invite..." : hasResendInvite === member.email && "Invite is resent" || "Resend invite"
                                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                            className: "inline-flex justify-center w-full px-4 py-2 mr-3 text-base font-medium leading-6 text-gray-700 bg-white sm:text-sm sm:leading-5",
                                                                                            children: member.status == "active" ? "Active" : "Pending"
                                                                                        }),
                                                                                        member.role !== "owner" && user.isTeamOwner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                                            className: "flex items-center justify-center px-3 py-2 text-sm text-white transition duration-150 ease-in-out bg-apricot-600 border border-transparent rounded-md hover:bg-apricot-500 focus:outline-none focus:border-apricot-700 focus:shadow-outline-red sm:text-sm sm:leading-5",
                                                                                            onClick: ()=>setShowConfirmModal(member.email),
                                                                                            children: "Delete"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, i);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "pt-5 border-t border-gray-200",
                                                                children: [
                                                                    user.isTeamOwner && !formOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "flex justify-between",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "rounded-md shadow-sm",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                                    className: "px-4 py-2 mt-4 text-sm text-summer-green-700 font-medium border-summer-green-300 transition duration-150 ease-in-out border border-transparent rounded-md bg-summer-green-100 hover:bg-summer-green-200 focus:outline-none focus:border-summer-green-700 md:mt-0",
                                                                                    onClick: ()=>copyTeamInviteLink(),
                                                                                    children: "Copy team sign up link"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "rounded-md shadow-sm",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                                    title: "Add a member",
                                                                                    onClick: ()=>setFormOpen(true)
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    formOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                                                                        onSubmit: handleSubmit(onSubmit),
                                                                        children: [
                                                                            error?.message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "p-2 mb-4 text-center text-apricot-500 border border-apricot-600 border-dashed rounded",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    children: error.message
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "flex justify-end",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                        className: "w-full mr-3 rounded-md",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                id: "email",
                                                                                                className: "block w-full px-3 py-2 placeholder-gray-400 transition duration-150 ease-in-out border border-gray-300 rounded-md appearance-none focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5",
                                                                                                type: "email",
                                                                                                name: "email",
                                                                                                placeholder: "Email",
                                                                                                ...register("email", {
                                                                                                    required: "Please enter an email",
                                                                                                    pattern: {
                                                                                                        value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                                                                                        message: "Not a valid email"
                                                                                                    }
                                                                                                })
                                                                                            }),
                                                                                            errors.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                                className: "mt-2 text-xs text-apricot-600",
                                                                                                children: errors.email.message
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                                            type: "submit",
                                                                                            title: "Add",
                                                                                            isLoading: !!isLoading
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "px-4 py-5 pt-5 mt-10 overflow-hidden bg-white rounded-lg shadow-lg sm:p-6",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                                className: "text-lg font-medium leading-6 text-gray-900",
                                                                children: "Your team"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "pt-3 mt-6 mb-3 border-t border-gray-200 sm:flex sm:items-start sm:justify-between ",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "text-sm leading-5 text-gray-500",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            children: `Name: ${team.name || ""}`
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                            children: `Member count: ${team.users.length}`
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "pt-5 border-t border-gray-200",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "flex justify-end",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "rounded-md shadow-sm",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                                            href: "/account/team/edit",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_shared_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                                title: "Edit"
                                                                            })
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    showConfirmModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dashboard_ConfirmModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        closeModal: ()=>setShowConfirmModal(false),
                        title: "Are you sure?",
                        text: "The team member will be deleted from your team. This user will lose all access to your team's resources. If there is still a pending invitation it will no longer be valid.",
                        confirmText: isLoading ? "Deleting..." : "Delete member",
                        confirmAction: ()=>deleteMember(showConfirmModal)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Team);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2876,5937,1664,5754,9319,9774,2888,179], function() { return __webpack_exec__(65736); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);